module.exports = __webpack_public_path__ + "static/semicircle-gray-06b5dca8271cfb02666418efefb4e50a.svg";